<template>
  <div ref="emotion" class="Emotion" :class="{ used: over == true }"> 
    <div ref="txt" class="Emotion__txt" :class="[{ left: id == 5 || id == 1 || id == 0 || id == 4 }]">
      <div class="title">{{ trans(txt +'_txt') }}</div>
      <div>{{ trans(txt +'_description') }}</div>
    </div>
    <div ref="shadow" class="Emotion__item shadow">
      <img :src="require('../img/emotions/' + txt + '_shadow.png')" />
    </div>
    <div 
      ref="head" 
      :id="id" 
      class="Emotion__item draggable" 
      :class="{ 'disable': disable }"  
      @mouseover="isOver()" 
      @mouseout="isOut()">
      <img :src="require('../img/emotions/' + txt + '.png')" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'Emotion',
  props: ['id', 'txt', 'pos', 'oeuvre_id'],
  data: () => ({
    disable: false,
    used: false,
    over: false,
    cfx: 0
  }),
  translations: {
    fr: { 
      content_txt: 'Contente ou content',
      content_description: 'Qui éprouve de la satisfaction face à une situation agréable.',
      curieux_txt: 'Curieuse ou curieux',
      curieux_description: 'Qui éprouve un désir de voir ou d’apprendre quelque chose.', 
      fache_txt: 'Fâchée ou fâché',
      fache_description: 'Qui éprouve du mécontentement.',  
      merveilleux_txt: 'Émerveillée ou émerveillé',
      merveilleux_description: 'Qui ressent un sentiment d’étonnement et d’admiration.', 
      neutre_txt: 'Neutre',
      neutre_description: 'Qui n’éprouve pas d’émotion particulière.',
      surpris_txt: 'Étonnée ou  étonné',
      surpris_description: 'Qui est surprise ou surpris face à une situation.',  
      triste_txt: 'Triste',
      triste_description: 'Qui ressent de la peine.',
      calme_txt: 'Calme',
      calme_description: 'Qui est apaisée ou apaisé par une situation.',
    },
    en: { 
      content_txt: 'Happy',
      content_description: 'Feeling satisfied with a pleasant situation.',
      curieux_txt: 'Curious',
      curieux_description: 'Feeling a desire to see or learn something.', 
      fache_txt: 'Angry',
      fache_description: 'Feeling upset or discontent.',
      merveilleux_txt: 'Amazed',
      merveilleux_description: 'Having feelings of astonishment and admiration.',  
      neutre_txt: 'Neutral',
      neutre_description: 'Having no particular emotion.',  
      surpris_txt: 'Surprised',
      surpris_description: 'Feeling startled by a situation.',
      triste_txt: 'Sad',
      triste_description: 'Feeling sorrow.',
      calme_txt: 'Calm',
      calme_description: 'Feeling serene about a situation.',
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  created() {
    window.addEventListener('resize', this.onResize)
  },
  mounted(){
    this.$nextTick(()=>{
      TweenMax.delayedCall(.5, ()=>{
        this.setPosition()
        TweenMax.delayedCall(1, this.show()) 
      })
    })
  },
  watch: {

    // current_drag(nw, od) {
    //   if(nw.id == this.id) {
    //     this.used = true
    //     this.isOut(0)
    //   }
    //   else 
    //     this.used = false
    // },
    // drag_end(nw, od) {
    //   if(nw.id == this.id)
    //     this.disable = true
    // },
    // drag_back(nw, od) {
    //   if(nw.id == this.id) {
    //     TweenMax.from(this.$refs.emotion, .7 ,{ scale: .5, ease: Cubic.easeOut, delay: .1 })
    //     this.disable = false
    //   }
    // },
    // is_over(nw, od) {
    //   if(nw == this.id) 
    //     this.over = true
    //   else 
    //     this.over = false  
    // }

    drag_end(nw, od) {
      if(nw.id == this.id) {
        this.disable = true
        if(navigator.maxTouchPoints == 5 || this.$root.$agent.tablet) 
          this.isOut(0)
      }
    },
    drag_back(nw, od) { 
      if(nw.id == this.id) {
        this.disable = false
      }
    },
    current_drag(nw, od) {
      if(navigator.maxTouchPoints == 5 && nw == null || this.$root.$agent.tablet && nw == null)  {
        this.isOut(0)
        this.used = false
      }
      else if(nw.id == this.id) {
        if(navigator.maxTouchPoints == 5 || this.$root.$agent.tablet) 
          this.isOver(0)
        else {
          
          this.isOut(0)
          this.used = true
        } 
      }
      else 
        this.used = false
    },
    is_over(nw, od) {
      if(nw == this.id) 
        this.over = true
      else 
        this.over = false  
    },
  },
  computed: {
    drag_end() { return this.$store.getters['app/drag_end'] },
    drag_back() { return this.$store.getters['app/drag_back'] },
    current_drag() { return this.$store.getters['app/current_drag'] },
    is_over() { return this.$store.getters['app/is_over'] },
  },
  methods: {
    show() {
      const delay = _.random(1, 1.75)
      this.$tween = new TimelineMax()
          .set(this.$refs.head, { scale: .2 })
          .set(this.$refs.shadow, { opacity: 0 })
          .add([
            TweenMax.to(this.$refs.emotion, .7 ,{ opacity: 1, ease: Cubic.easeOut, delay: delay }),
            TweenMax.to(this.$refs.head, .7 ,{ scale: 1, ease: Cubic.easeOut, delay: delay }),
            TweenMax.to(this.$refs.shadow, .7 ,{ opacity: 1, ease: Cubic.easeOut, delay: delay+.1 })
          ])
    },
    onResize() {
      this.setPosition()
    },
    setPosition() {

      // 214 - "o_ADAD_HANNAH"
      // 216 - "o_ANNIE_BAILLARGEON"
      // 218 - "o_CLAUDIE_GAGNON"
      // 220 - "o_HUA_JIN"
      // 224 - "o_JONAS_ST_MICHAEL"
      // 226 - "o_PATRICK_BERNATCHEZ"
      // 233 - "o_MARISA_PORTOLESE"
      // 240 - "o_MORIDJA_KITENGE_BANZA"
      // 242 - "o_JJ_LEVINE"
      // 244 "o_SKAWENNATI"

      let cfx = 0

      // if(this.oeuvre_id == 214 
      // || this.oeuvre_id == 216
      // || this.oeuvre_id == 224){
      //   cfx = (this.pos[0] > 0) ? -100 : 100
      // }
      // else if(this.oeuvre_id == 226){
      //   cfx = (this.pos[0] > 0) ? 40 : -40
      // }

      switch(this.oeuvre_id){

        case 233:
          cfx = (this.pos[0] > 0) ? -25 : 25
          break

        case 224:
        case 242:
        case 240:
          cfx = (this.pos[0] > 0) ? -40 : 40
          break

        case 226:
          cfx = (this.pos[0] > 0) ? 30 : -30
          break

        case 216:
          cfx = (this.pos[0] > 0) ? -70 : 70
          break

        case 220:
          cfx = (this.pos[0] > 0) ? -65 : 65
          break

        default:
          cfx = (this.pos[0] > 0) ? -100 : 100

      }

      if(window.innerWidth >= 1200) cfx = 0

      this.cfx = cfx

      const cfy = (this.oeuvre_id == 226) ? .45 : .5
      const coef = (window.innerWidth <= 1200) ? .75 : 1
      const bounds = this.$refs.emotion.getBoundingClientRect()
      const inw = window.innerWidth/2
      const wid = 61
      const inh = window.innerHeight/2
      const heg = 62
      const psx = (inw - wid + (this.pos[0]*.5)*coef) + cfx
      const psy = inh - heg + (this.pos[1]*.5)*coef
      TweenMax.set(this.$refs.emotion, { x: psx  , y: psy })
    },
    isOver(_delay) {
      if(this.used)
        return
      const delay = (_delay) ? _delay : .35
      this.$store.commit('app/IS_OVER', this.id)
      TweenMax.to(this.$refs.txt, .5, { opacity: 1, x: 0, delay: .35 })

    },
    isOut(_delay) {
      const delay = (_delay) ? _delay : .35
      const pos = (this.id == 5 || this.id == 1 || this.id == 0 || this.id == 4) ? 50 : -50
      TweenMax.to(this.$refs.txt, .25, { opacity: 0, x: pos, delay: delay })
    },
  },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Emotion
  position absolute
  opacity 0
  z-index 2000
  // border 1px solid red

  &.used 
      z-index 3000

  &__item
    width 121px
    height 121px
    padding 0 16px
    border-radius 18px
    display flex
    justify-content center
    align-items center
    cursor pointer 
    transition opacity .25s 

    +max-screen-height(tablet-portrait)
      width 120px

    &.disable 
      opacity 0
      pointer-events none

    &.shadow
      position absolute
      top 0
      pointer-events none
      opacity .5

  &__txt 
    position absolute
    background black
    font-size 13px
    line-height 18px
    padding 8px 8px 10px 8px
    width 160px
    top -50%
    left -100%
    pointer-events none
    opacity 0
    transform translate(-50px, 50%)

    &.left
      left 100%
      transform translateX(50px)

  & .title 
      font-weight bold
      padding-bottom 4px

  &__test
    position absolute
    display flex
    flex-direction column
    font-size 12px
    line-height 16px
    top 0
    left 0



</style>































































// WEBPACK FOOTER //
// src/components/defis/components/Emotion.vue